import styled from 'styled-components';
import { MainCarousel } from '../../Home/HomePage/components/MainCarousel';
import { useGetBannersQuery } from '../../../hooks/banners/queries/useGetBanners.query';

interface IOpenMarketCarouselBanners {
  outputLocation: 'tractor-poking' | 'open-market';
  category: 'CAROUSEL_MAIN' | 'CAROUSEL_SUB';
}

export const OpenMarketCarouselBanners = ({ outputLocation, category }: IOpenMarketCarouselBanners) => {
  const { data: openMarketCarouselImages, isLoading: isGetOpenMarketCarouselImagesQueryLoading } = useGetBannersQuery({
    searchParam: {
      category,
      outputLocation,
    },
  });

  return (
    openMarketCarouselImages &&
    openMarketCarouselImages.length > 0 && (
      <Container>
        <MainCarousel carouselImages={openMarketCarouselImages} pageType={'olp'} position={'top'} />
      </Container>
    )
  );
};

const Container = styled.div`
  display: flex;
  padding-bottom: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);

  align-self: stretch;
`;
